"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4.07 13H2.05c.2 2.01 1 3.84 2.21 5.33l1.43-1.43c-.86-1.11-1.44-2.44-1.62-3.9zm1.62-5.9L4.26 5.67C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM11 4.07V2.05c-2.01.2-3.84 1-5.33 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.33.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.43-1.43zm-.02 12.64 1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.33h-2.02c-.18 1.46-.76 2.79-1.62 3.9zm1.62-5.9h2.02c-.2-2.01-1-3.84-2.21-5.33L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM13 19.93v2.02c2.01-.2 3.84-1 5.33-2.21l-1.43-1.43c-1.11.86-2.44 1.44-3.9 1.62zm-7.33-.19c1.48 1.21 3.32 2.01 5.33 2.21v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.43 1.43z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
  cx: "12",
  cy: "12",
  r: "5"
}, "1")], 'NoiseAwareTwoTone');

exports.default = _default;